import { capitalizeText } from '@cat-ecom/common/utils/commonUtils';

export const formatJobName = (jobName: string): string => {
  return jobName
    .split(' ')
    .map((word) => (word.toLowerCase() === 'pm' ? 'PM' : capitalizeText(word)))
    .join(' ');
};
